import { defineComponent as _defineComponent } from 'vue'
import { computed, reactive, watch } from 'vue';
import CSelect, { valueReducer } from '@/components/shared/CSelect';
import CCheckbox from '@/components/shared/CCheckbox.vue';
import type { CanvasEx } from '@/typings/canvas';
import type { ImagePlaceholderElement } from '@/typings/customilyElements/canvasElements';
import { Quality, Size, Background } from '@/typings/customilyElements/imageToImageType';


export default /*#__PURE__*/_defineComponent({
  __name: 'ImageToImageProperties',
  props: {
    canvas: null,
    imageElement: null,
    editMode: { type: Boolean },
    readonly: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
    canvas: CanvasEx;
    imageElement: ImagePlaceholderElement;
    editMode?: boolean;
    readonly?: boolean;
};

const DEFAULT_CONFIG = {
    quality: Quality.HIGH,
    size: Size.AUTO,
    background: Background.AUTO,
    stream: false
} as const;

const CONFIG_OPTIONS = {
    quality: [
        { label: 'High (default)', value: Quality.HIGH },
        { label: 'Medium', value: Quality.MEDIUM },
        { label: 'Low', value: Quality.LOW },
        { label: 'Auto', value: Quality.AUTO }
    ],
    size: [
        { label: '1024x1024 (square)', value: Size.SQUARE },
        { label: '1536x1024 (landscape)', value: Size.LANDSCAPE },
        { label: '1024x1536 (portrait)', value: Size.PORTRAIT },
        { label: 'Auto (default)', value: Size.AUTO }
    ],
    background: [
        { label: 'Transparent', value: Background.TRANSPARENT },
        { label: 'Opaque', value: Background.OPAQUE },
        { label: 'Auto (default)', value: Background.AUTO }
    ]
};



const model = reactive({
    quality: props.imageElement?.imageToImageConfig?.quality || DEFAULT_CONFIG.quality,
    size: props.imageElement?.imageToImageConfig?.size || DEFAULT_CONFIG.size,
    background: props.imageElement?.imageToImageConfig?.background || DEFAULT_CONFIG.background,
    stream: props.imageElement?.imageToImageConfig?.stream || DEFAULT_CONFIG.stream
});

const isDisabled = computed(() => !!props.imageElement?.locked);

const updateImageToImageConfig = () => {
    if (!props.imageElement || isDisabled.value) return;

    const newConfig = {
        ...props.imageElement.imageToImageConfig,
        quality: model.quality,
        size: model.size,
        background: model.background,
        stream: model.stream
    };

    props.imageElement.set('imageToImageConfig', newConfig);

    if (props.editMode) {
        props.imageElement.setEditedProp('imageToImageConfig');
    }

    props.canvas.requestRenderAll();
};

watch(
    () => props.imageElement,
    () => {
        const newConfig = props.imageElement?.imageToImageConfig;
        model.quality = newConfig?.quality || DEFAULT_CONFIG.quality;
        model.size = newConfig?.size || DEFAULT_CONFIG.size;
        model.background = newConfig?.background || DEFAULT_CONFIG.background;
        updateImageToImageConfig();
    },
    { immediate: true }
);

return { __sfc: true,DEFAULT_CONFIG, CONFIG_OPTIONS, props, model, isDisabled, updateImageToImageConfig, CSelect, valueReducer, CCheckbox }
}

})